(() => {
  const updateLinks = (card, url, title) => {
    if (!url) return;
    card.querySelectorAll('a.link-product-variant').forEach((link) => {
      link.href = url;
      if (title) {
        link.setAttribute('aria-label', title);
      }
    });
    card.dataset.link = url;
  };

  const updateTitle = (card, title) => {
    if (!title) return;
    card.querySelectorAll('.x-card-title').forEach((el) => {
      el.textContent = title;
    });
  };

  const updateImage = (card, image, title) => {
    if (!image) return;
    const img = card.querySelector('picture img');
    if (!img) return;
    img.src = image;
    img.srcset = image;
    if (title) {
      img.alt = title;
    }
  };

  const updateVariant = (card, variantId) => {
    if (!variantId) return;
    card.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = variantId;
    });
  };

  const updateBadges = (card, subitem) => {
    const el = card.querySelector('[x-labels-data]');
    if (!el || !Alpine?.store('xBadges')) return;

    const priceRaw = Number(subitem.dataset.priceRaw);
    const compareRaw = Number(subitem.dataset.compareRaw);
    const available = subitem.dataset.available === 'true';

    let labelsData = null;
    try { labelsData = JSON.parse(el.getAttribute('x-labels-data')); } catch(e) { return; }
    if (!labelsData || !labelsData[0]) return;

    labelsData[0].price = priceRaw;
    labelsData[0].compare_at_price = compareRaw;
    labelsData[0].available = available;

    el.setAttribute('x-labels-data', JSON.stringify(labelsData));
    Alpine.store('xBadges').loadingEl.delete(el);
    Alpine.store('xBadges').load(el, () => {}, null, true);
  };

  const updatePrice = (card, price, compare) => {
    if (!price) return;
    const priceContainer = card.querySelector('.x-card-price');
    if (!priceContainer) return;

    let saleEl = priceContainer.querySelector('.price-sale');
    let compareEl = priceContainer.querySelector('.price-compare');
    const priceSpan = priceContainer.querySelector('.price span');
    const hasCompare = compare && compare !== '0' && compare !== price;

    if (hasCompare) {
      if (!compareEl) {
        const targetSpan = saleEl || priceSpan;
        if (targetSpan) {
          const compareWrapper = document.createElement('small');
          compareWrapper.className = 'cap rtl:inline-block';
          const compareNode = document.createElement('s');
          compareNode.className = 'price-compare rtl:leading-tight';
          compareNode.textContent = compare;
          compareWrapper.appendChild(compareNode);
          targetSpan.before(compareWrapper);
          compareEl = compareNode;
        }
      } else {
        const compareWrapper = compareEl.closest('small');
        compareWrapper?.classList.remove('hidden');
        compareEl.textContent = compare;
      }

      if (!saleEl) {
        const targetSpan = priceSpan || priceContainer.querySelector('.price span');
        if (targetSpan) {
          targetSpan.classList.add(
            'price-sale',
            'selection:bg-text-[rgb(var(--colors-price-sale),0.2)]',
            'ml-1'
          );
          saleEl = targetSpan;
        }
      }

      if (saleEl) {
        saleEl.textContent = price;
      } else if (priceSpan) {
        priceSpan.textContent = price;
      } else {
        priceContainer.textContent = price;
      }
    } else {
      if (compareEl) {
        const compareWrapper = compareEl.closest('small');
        compareEl.textContent = '';
        compareWrapper?.classList.add('hidden');
      }
      if (saleEl) {
        saleEl.textContent = price;
        saleEl.classList.remove(
          'price-sale',
          'selection:bg-text-[rgb(var(--colors-price-sale),0.2)]',
          'ml-1'
        );
      } else if (priceSpan) {
        priceSpan.textContent = price;
      } else {
        priceContainer.textContent = price;
      }
    }
  };

  const onSubitemClick = (event) => {
    const subitem = event.target.closest('.fam__subitem');
    if (!subitem) return;

    const card = subitem.closest('[data-proid]');
    if (!card) return;

    event.preventDefault();

    const wrapper = subitem.closest('.fam__wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.fam__subitem.select').forEach((el) => {
        el.classList.remove('select');
      });
      subitem.classList.add('select');
    }

    const { url, title, price, compare, image, idvariant } = subitem.dataset;
    updateLinks(card, url, title);
    updateTitle(card, title);
    updatePrice(card, price, compare);
    updateImage(card, image, title);
    updateVariant(card, idvariant);
    updateBadges(card, subitem);
  };

  document.addEventListener('click', onSubitemClick);
})();
